"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = wrapPageElement;
var _react = _interopRequireDefault(require("react"));
var _components = require("@bluefin/components");
function wrapPageElement(_ref, pluginOptions) {
  var element = _ref.element;
  var botId = pluginOptions.botId,
    clientId = pluginOptions.clientId,
    merchantId = pluginOptions.merchantId,
    _pluginOptions$botpre = pluginOptions.botpressConfig,
    botpressConfig = _pluginOptions$botpre === void 0 ? {} : _pluginOptions$botpre;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, element, /*#__PURE__*/_react["default"].createElement(_components.BotpressProvider, {
    botId: botId,
    clientId: clientId,
    merchantId: merchantId,
    botpressConfig: botpressConfig
  }));
}